import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-select-all",
  templateUrl: "./med-icon-select-all.component.html",
})
export class MedIconSelectAllComponent extends SvgMixinComponent {}
